import { BooleanField } from "@overmap-ai/forms"
import type { ReactNode } from "react"

import { BooleanNotEqualsFilterModifier, NullableBooleanEqualsFilterModifier } from "../../modifiers"
import { BaseFilterDef, createFilterModifierConfig, type FilterDefRenderProps } from "../BaseFilterDef"
import { BooleanFieldFilterCell } from "./BooleanFieldFilterCell"

type BooleanFieldValue = boolean | null
type BooleanFilterValue = boolean | null

export class BooleanFieldFilterDef extends BaseFilterDef<BooleanFieldValue, BooleanFilterValue> {
	readonly id: string
	readonly defaultFilterValue: BooleanFilterValue | undefined = undefined
	readonly defaultFilterModifier: keyof typeof this.modifiers = "equals"
	readonly field: BooleanField

	constructor(field: BooleanField) {
		super()
		this.field = field
		this.id = field.id
	}

	readonly modifiers = {
		equals: createFilterModifierConfig({
			modifier: NullableBooleanEqualsFilterModifier,
			isValueValid: (_value: BooleanFieldValue): _value is boolean | null => true,
			isFilterValueValid: (_value: BooleanFilterValue): _value is boolean | null => true,
		}),
		notEquals: createFilterModifierConfig({
			modifier: BooleanNotEqualsFilterModifier,
			isValueValid: (_value: BooleanFieldValue): _value is boolean | null => true,
			isFilterValueValid: (_value: BooleanFilterValue): _value is boolean | null => true,
		}),
	}

	render(props: FilterDefRenderProps<BooleanFieldFilterDef>): ReactNode {
		return <BooleanFieldFilterCell key={props.filter.id} field={this.field} {...props} />
	}
}
